import { header } from './modules/header';
import { slider } from './modules/slider';
import { modal } from './modules/modal';
import { animation } from './modules/animation';
header();
slider();
modal();
animation();